import auth from '@/middleware/modules/auth'

const QueryEdit = () => import(/* webpackChunkName: "_v-queries" */ '@/views/queries/QueryEdit.vue')
const QueriesIndex = () => import(/* webpackChunkName: "_v-queries" */ '@/views/queries/QueriesIndex.vue')
const QueryView = () => import(/* webpackChunkName: "_v-queries" */ '@/views/queries/QueryView.vue')

export default [
  {
    path: 'queries',
    name: 'queries',
    props: (route) => ({ querySearch: route.query.search }),
    component: QueriesIndex,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
  },
  {
    path: 'query/new',
    name: 'query-new',
    component: QueryEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['queries'],
    },
  },
  {
    path: 'query/edit/:id',
    name: 'query-edit',
    component: QueryEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['queries'],
    },
  },
  {
    path: 'query/:id',
    name: 'query-view',
    component: QueryView,
    props: (route) => ({ queryID: parseInt(route.params.id), querySearch: route.query.search }),
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['queries'],
    },
  },
]
